<template>
  <div class="verificationresultconsole">
    <div class="commonpageheader">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{name: 'Subscription'}">订阅管理</el-breadcrumb-item>
        <el-breadcrumb-item>商品判定结果管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="filterbox">
      <div class="smallelform">
        <el-form size="small" label-width="70px">
          <el-form-item label="订阅名称">{{baseinfo.TaskName}}</el-form-item>
          <el-form-item label="TaskID">{{baseinfo.TaskID}}</el-form-item>
        </el-form>
      </div>
      <el-row>
        <el-col :span="16">
          <el-form size="small" label-width="70px">
            <el-form-item label="关键词">
              <el-input @keyup.enter.native="getResultList()" v-model="query.search" placeholder="请输入关键词" class="matchresultconsolekeywords"></el-input>
              <el-button type="primary" @click="getResultList()">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="8">
          <div class="setallfeedback">
            <el-tag>剩余未反馈({{ feedbackcounts }})</el-tag>
            <el-button v-if="!disabled3" :disabled="feedbackcounts/1 === 0" icon="el-icon-circle-check" type="success" size="small" @click="setAllRead()">当前页全部设为已反馈</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="commontable">
      <div class="tablebox">
        <el-table :cell-style="getCellStyle" size="mini" v-loading="loading" :data="tablelist">
          <el-table-column width="30px">
            <template slot-scope="scope">
              <span class="reviewtypeicon" :class="scope.row.CheckTime !== null ? 'isreadtype' : ''"></span>
            </template>
          </el-table-column>
          <el-table-column prop="AssetID" label="AssetID" width="120px" show-overflow-tooltip></el-table-column>
          <el-table-column label="商品标题" show-overflow-tooltip>
            <template slot-scope="scope">
              <a :href="scope.row.AssetURL" target="_blank">{{ scope.row.AssetTitle }}</a>
            </template>            
          </el-table-column>
          <el-table-column prop="AssetContent" label="商品描述" width="150px" show-overflow-tooltip></el-table-column>
          <el-table-column prop="Shopname" label="卖家名称" width="200px" show-overflow-tooltip></el-table-column>
          <el-table-column label="判定准确性" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.DiscriminantResult === 3" title="高">
                <i class="clbn-icon clbn-yellow el-icon-star-on"></i>
                <i class="clbn-icon clbn-yellow el-icon-star-on"></i>
                <i class="clbn-icon clbn-yellow el-icon-star-on"></i>
              </span>
              <span v-if="scope.row.DiscriminantResult === 2" title="中">
                <i class="clbn-icon clbn-yellow el-icon-star-on"></i>
                <i class="clbn-icon clbn-yellow el-icon-star-on"></i>
                <i class="clbn-icon clbn-grey el-icon-star-on"></i>              
              </span>
              <span v-if="scope.row.DiscriminantResult === 1" title="低">
                <i class="clbn-icon clbn-yellow el-icon-star-on"></i>
                <i class="clbn-icon clbn-grey el-icon-star-on"></i>
                <i class="clbn-icon clbn-grey el-icon-star-on"></i>              
              </span>
            </template>          
          </el-table-column>
          <el-table-column label="判定结果" width="70px">
            <template slot-scope="scope">
              <span v-if="scope.row.DiscriminantResult/1 === 1">真</span>
              <span v-if="scope.row.DiscriminantResult/1 === 0">假</span>
            </template>
          </el-table-column>
          <el-table-column v-if="!disabled3" label="判定反馈" width="120px">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.CheckResult" @change="verificationResultEdit(scope.row.AssetID, scope.row.CheckResult/1, scope.row, scope.$index)" size="mini">
                <el-radio-button label="1">真</el-radio-button>
                <el-radio-button label="0">假</el-radio-button>
              </el-radio-group>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-pagination">
        <el-pagination
          small
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          popper-class="pagesizeclass"
          :page-sizes="[25, 50, 100]"
          :page-size="query.size"
          layout="total, prev, pager, next, sizes"
          :total="totalbrand"
        ></el-pagination>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      keywords: "",
      loading: false,
      query: {
        subid: this.$route.params.subid,
        search: '',
        page: 1,
        size: this.getLocalStorage('pagesize8') ? this.getLocalStorage('pagesize8') * 1 : 25
      },
      currentPage: 1,
      tablelist: [],
      totalbrand: 0,
      baseinfo: {
        name: '',
        id: ''
      },
      assetidlist: '',
      feedbackcounts: '',
      disabled1: this.getLocalStorage('level')/1 === 1 ? true : false,
      disabled3: this.getLocalStorage('level')/1 === 3 ? true : false
    }
  },

  mounted(){
    let that = this
    that.getBaseInfo()
    that.getFeedbackCount()
    that.getResultList()
  },

  methods: {

    getCellStyle({ column }) {
      // TODO 针对Safari表格width与showOverflowTooltip暂不能共存异常
      const tempWidth = column.realWidth || column.width
      if (column.showOverflowTooltip) {
        return {
          minWidth: tempWidth + 'px',
          maxWidth: tempWidth + 'px'
        }
      }

      return {}
    },

    /**
     * 切换每页显示条目数
     */
    handleSizeChange(val) {
      let that = this
      that.currentPage = 1
      that.query.page = 1
      that.query.size = val
      that.setLocalStorage('pagesize8', val)
      that.getFeedbackCount()
      that.getResultList()
    },

    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      let that = this
      that.query.page = val
      that.getFeedbackCount()
      that.getResultList()
    },

    /**
     * 获取判定结果数据list
     */
    getResultList: function(){
      let that = this
      let url = that.API_URL + '/sys/result/list'
      that.loading = true
      that.tablelist = []
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: that.query,
        success: function(data) {
          console.log('getResultList', data)
          that.totalbrand = data.results[0][0].Count
          let lists = data.results[1]
          // lists.forEach(function(res){
          //   res.DiscriminantTime = that.$moment(res.DiscriminantTime).utc().format('YYYY-MM-DD hh:mm')
          // })
          that.tablelist = lists
          let _assetidlist = []
          for(let i=0; i<lists.length; i++){
            _assetidlist.push(lists[i].AssetID)
          }
          that.assetidlist = _assetidlist.join(',')
          that.loading = false
        },
        error: function(response) {
          console.log('getResultList', response)
        }
      })
    },
    
    /**
     * 获取订阅基本信息
     */
    getBaseInfo: function(){
      let that = this
      let url = that.API_URL + '/sys/match/view'
      let query = {subid: that.query.subid}
      that.loading = true
      that.tablelist = []
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getBaseInfo', data)
          let info = data.results[0]
          that.baseinfo = info
        },
        error: function(response) {
          console.log('getBaseInfo', response)
        }
      })
    },

    /**
     * 判定结果反馈
     */
    verificationResultEdit: function(aid, rst, row, index){
      let that = this
      let url = that.API_URL + '/sys/result/edit'
      let query = {
        subid: that.query.subid,
        assetid: aid,
        result: rst
      }
      console.log('当前数据行', row)
      console.log('当前数据行Index', index)
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('verificationResultEdit', data)
          that.tablelist[index].CheckTime = new Date()
        },
        error: function(response) {
          console.log('verificationResultEdit', response)
        }
      })      
    },

    /**
     * 全部设为已读
     */
    setAllRead: function(){
      let that = this
      let url = that.API_URL + '/sys/result/read'
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {subid: that.query.subid, assetidlist: that.assetidlist},
        success: function(data) {
          console.log('setAllRead', data)
          that.getFeedbackCount()
          that.getResultList()
        },
        error: function(response) {
          console.log('setAllRead', response)
        }
      })
    },

    /**
     * 获取未反馈条目数
     */
    getFeedbackCount: function(){
      let that = this
      let url = that.API_URL + '/sys/result/todo'
      let query = {subid: that.query.subid, search: that.query.search}
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getFeedbackCount', data)
          that.feedbackcounts = data.results[0].Count
        },
        error: function(response) {
          console.log('getFeedbackCount', response)
        }
      })
    },
    
  }
}
</script>
